module.exports = __webpack_public_path__ + "static/media/ExpertImage_Mark.b2ea8c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/ExpertImage_Mark.jpg
// module id = 3806
// module chunks = 0